import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Grid, Header } from 'semantic-grab-ui/src';
import { StoreState } from 'reducers';
import { TridentCampaignDetails } from 'types/trident-campaigns';
import ActionAwardPointsForm from './ActionAwardPointsForm';
import ActionSendSlackForm from './ActionSendSlackForm';
import ActionAwardRewardForm from './ActionAwardRewardForm';
import ActionSendGrabChat from './ActionSendGrabChat';
import MintActionForm from './MintActionForm';
import AutoGeneratedActionForm from './AutoGeneratedActionForm';
import ActionupdateSegmentMembershipForm from './ActionupdateSegmentMembershipForm';
import ActionAwardSubscriptionForm from './ActionAwardSubscriptionForm';
import ActionAwardNFTForm from './ActionAwardNFTForm';
import NewActionSendPushNotification from './NewActionSendPushNotification';
import ActionUpdateQuest from './ActionUpdateQuest';
import ActionOptInChallenge from './ActionOptInChallenge';
import {
  constructFormConstraints,
  getActionAwardNFTConstraints,
  getActionAwardSubscriptionConstraints,
  getActionSendGrabChatConstraints,
  getActionUpdateSegmentMembershipConstraints,
  getAwardPointConstraints,
  getAwardRewardConstraints,
  getNewActionSendPushConstraints,
  getOptInChallengeConstraints,
  getUpdateQuestConstraints,
} from './constraints';
import { getActionConfig, getListOfHedwigActions } from 'omega-rtc/utils/new-trident-utils';

interface Props {
  onModelChange: Function,
  model: TridentCampaignDetails,
  currentNode: string, // node ID
  subActionIndex: number,
  actionType: string,
  parentKeyList?: string[], // used in ActionAwardRewardForm only
  disableEdit: boolean,
  formRef: Function, // for SubActionForm to perform error checking on meta forms
  listRuleTypes: object,
}

// SubActionMetaForm lets user edit or view action meta
class SubActionMetaForm extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    const action = _.get(this.props.model, `nodes[${this.props.currentNode}].data[${this.props.subActionIndex}]`, {});
    this.state = {
      type: action.type,
      meta: action.meta,
    };
  }

  onSubActionChange = (meta: Object) => {
    this.setState({
      meta,
    });
    _.set(this.props.model, `nodes[${this.props.currentNode}].data[${this.props.subActionIndex}].meta`, meta);
    this.props.onModelChange(this.props.model);
  };

  render() {
    const hedwigActions = getListOfHedwigActions(this.props.listRuleTypes);
    let actionType = this.props.actionType;
    if (hedwigActions.indexOf(actionType) !== -1) {
      actionType = 'rtcAction';
    }

    const { listRuleTypes, currentNode, subActionIndex, formRef } = this.props;
    const actionConfig = getActionConfig(listRuleTypes, this.props.actionType);
    if (_.get(actionConfig, 'autoGenerateFormEnabled', false)) {
      const autoGenerateFormConfig = _.get(actionConfig, 'autoGenerateForm', {});
      const formFields = _.get(autoGenerateFormConfig, 'fields', []);
      return (<AutoGeneratedActionForm
        {...this.props} ref={formRef}
        constraints={constructFormConstraints(currentNode, subActionIndex, formFields)}
        actionForm={autoGenerateFormConfig}
      />);
    }

    switch (actionType) {
      case 'rtcAction': {
        const actionNewSendPushConstraints = getNewActionSendPushConstraints(this.props.currentNode, this.props.subActionIndex);
        return (<NewActionSendPushNotification
          {...this.props}
          actionMeta={_.get(this.state, 'meta')}
          targetUserType={this.props.model.targetUserType}
          onChange={this.onSubActionChange}
          constraints={actionNewSendPushConstraints}
          ref={this.props.formRef}
        />);
      }
      case 'awardReward':
      case 'awardRewardToFamilyHost':
      case 'bulkAwardReward': {
        const awardRewardConstraints = getAwardRewardConstraints(this.props.currentNode, this.props.subActionIndex);
        return <ActionAwardRewardForm {...this.props} constraints={awardRewardConstraints} ref={this.props.formRef} />;
      }
      case 'updateQuest':
      case 'updateQuestToFamilyHost': {
        const actionUpdateQuestConstraints = getUpdateQuestConstraints(this.props.currentNode, this.props.subActionIndex);
        return <ActionUpdateQuest {...this.props} constraints={actionUpdateQuestConstraints} ref={this.props.formRef} />;
      }
      case 'sendSlack':
        return <ActionSendSlackForm {...this.props} />;
      case 'awardSubscription': {
        const actionAwardSubscriptionConstraints = getActionAwardSubscriptionConstraints(this.props.currentNode, this.props.subActionIndex);
        return <ActionAwardSubscriptionForm {...this.props} constraints={actionAwardSubscriptionConstraints} ref={this.props.formRef} />;
      }
      case 'awardNFT': {
        const actionAwardNFTConstraints = getActionAwardNFTConstraints(this.props.currentNode, this.props.subActionIndex);
        return <ActionAwardNFTForm {...this.props} constraints={actionAwardNFTConstraints} ref={this.props.formRef} />;
      }
      case 'awardPointToFamilyHost':
      case 'awardPoint': {
        const awardPointConstraints = getAwardPointConstraints(this.props.currentNode, this.props.subActionIndex);
        return <ActionAwardPointsForm {...this.props} constraints={awardPointConstraints} ref={this.props.formRef} />;
      }
      case 'updateFamilyHostSegmentMembership':
      case 'updateSegmentMembership':
      case 'updateDaxGroupMembership':
      case 'updateMexGroupMembership':
      case 'updatePaxDigibankSegmentMembership': {
        const actionUpdateSegmentMembershipConstraints = getActionUpdateSegmentMembershipConstraints(this.props.currentNode, this.props.subActionIndex, this.props.parentKeyList);
        return <ActionupdateSegmentMembershipForm {...this.props} constraints={actionUpdateSegmentMembershipConstraints} ref={this.props.formRef} />;
      }
      case 'sendGrabChat': {
        const actionSendGrabChatConstraints = getActionSendGrabChatConstraints(this.props.currentNode, this.props.subActionIndex);
        return <ActionSendGrabChat {...this.props} constraints={actionSendGrabChatConstraints} ref={this.props.formRef} />;
      }
      case 'optInChallenge': {
        const actionOptInChallengeConstraints = getOptInChallengeConstraints(this.props.currentNode, this.props.subActionIndex);
        return <ActionOptInChallenge {...this.props} constraints={actionOptInChallengeConstraints} ref={this.props.formRef} />;
      }
      case 'mintAction': {
        return <MintActionForm {...this.props} />;
      }
      default:
        return <Header.Subheader as={Grid.Column}>{`${this.props.actionType} is currently not supported.`}</Header.Subheader>;
    }
  }
}

function mapStateToProps(state: StoreState) {
  return {
    listRuleTypes: _.get(state, 'newTridents.listRuleTypes', {}),
  };
}

export default connect(mapStateToProps, {})(SubActionMetaForm);
